import logo from './logo.svg';
import './App.css';
import React from 'react';
import { serverURL } from './index'
import { checkForUUID } from './api/retrieveUUID'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { checkMessageCreated, storeData } from './api/sendMessage';

var test = {"text": "hello"};


    
// var clearAsyncStorage = async() => {
//   AsyncStorage.clear();
// }
// clearAsyncStorage();


class Input extends React.Component {
  disable = "";

  constructor(props) {
    super(props);

    this.state = { disabled: this.disable }
    this.handleClick = this.handleClick.bind(this);
  }

componentDidMount(){
  checkMessageCreated().then(response => {
    this.disable = response == "true"
    this.setState({ disabled: this.disable })
  });
}

  handleClick(e) {
    this.setState({
      disabled: true
    });
    storeData("true");
  }
  render() {
    return(
      <span id="bottom_bar" ><nobr>
        <input type="text" placeholder="Enter value" id="input_box" disabled={(this.state.disabled)? "disabled" : ""}/>
        <button id="send_button" onClick={this.handleClick}>
            <span id="send_button_text">
              &gt;
            </span>
        </button>
      </nobr></span>
    );
  }
};

class App extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = { 
      apiResponse: ""
    };
  }

  callAPI() {
    fetch(serverURL + "/testAPI")
        .then(res => res.text())
        .then(res => this.setState({ apiResponse: res }))
        .catch(err => err);
    
      
    fetch(serverURL + "/messageAPI", {
      method: 'POST',
      headers: {
        'Content-type': 'application/json' // The type of data you're sending
      },
      body: JSON.stringify(test)
    }).then((result) => result.text())
    .then((info) => { console.log(info); });
  }

  componentDidMount() {
    checkForUUID().then((response) => console.log(response));
    //checkMessageCreated().then((response) => Input.state.disabled = response)
    this.callAPI();
  }

  render(){
    return (
      <>
        <div id="header">
            <span className="title" id="title_one">
                ONE
            </span>
            <h1>
                <span className="title">
                    MESSAGE
                </span>
            </h1>
            <nav>
            </nav>
        </div>
        <div id="content">
          <Input></Input>
        </div>
        <div>
        </div>
      </>
    );
  }
}

export default App;
